import { StubTabBody, StubTabRow } from "./_StubTab";

export function ClientTab(): JSX.Element {
  return (
    <StubTabBody summary="Client robustness — failure modes that break under StrictMode, server crashes, and RPC outages.">
      <StubTabRow
        label="force component remount (StrictMode-style)"
        hint="Reproduces the Colyseus ghost-session bug on demand by unmounting and remounting the room loader."
      />
      <StubTabRow
        label="kill Colyseus connection"
        hint="Drops the active room socket so the reconnect path can be exercised without restarting the server."
      />
      <StubTabRow
        label="freeze RPC briefly"
        hint="Intercept connection calls and reject them for a short window. Verifies the polling loop stops on Settled and the UI degrades cleanly."
      />
      <StubTabRow
        label="trigger StrictMode double-mount"
        hint="Force a dev-mode-style double effect to confirm session cleanup runs on the cancelled-during-await path."
      />
    </StubTabBody>
  );
}
